"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../utils.js";
import { DropdownContext, useDropdownContext } from "./context.js";
import { PrimitiveDropdown, PrimitiveDropdownClientSearch, PrimitiveDropdownContent, PrimitiveDropdownEmpty, PrimitiveDropdownTrigger, PrimitiveDropdownValueButton } from "./primitive-dropdown/primitive-dropdown.js";
import * as __rspack_external_react from "react";
const Dropdown = ({ children, defaultSelected = [], selected, defaultOpen = false, open: controlledOpen, onOpenChange: onControlledOpenChange, ...popoverProps })=>{
    const [uncontrolledOpen, setUncontrolledOpen] = __rspack_external_react.useState(defaultOpen);
    const initialValues = selected || defaultSelected;
    const [values, setValues] = __rspack_external_react.useState(Array.isArray(initialValues) ? initialValues.map((item)=>item.value) : [
        initialValues.value
    ]);
    const [items, setItems] = __rspack_external_react.useState(Array.isArray(initialValues) ? initialValues : [
        initialValues
    ]);
    const selectedItems = __rspack_external_react.useMemo(()=>{
        if (selected) return Array.isArray(selected) ? selected : [
            selected
        ];
        const selectedArray = [];
        values.forEach((value)=>{
            const item = items.find((item)=>item.value === value);
            if (item) selectedArray.push(item);
        });
        return selectedArray;
    }, [
        selected,
        values,
        items
    ]);
    const open = controlledOpen ?? uncontrolledOpen;
    const setOpen = onControlledOpenChange ?? setUncontrolledOpen;
    return /*#__PURE__*/ jsx(DropdownContext.Provider, {
        value: {
            open,
            values,
            items,
            selectedItems,
            setOpen,
            setValues,
            setItems
        },
        children: /*#__PURE__*/ jsx(PrimitiveDropdown, {
            open: open,
            onOpenChange: setOpen,
            ...popoverProps,
            children: children
        })
    });
};
const DropdownTrigger = PrimitiveDropdownTrigger;
const DropdownValue = ({ className, placeholder, size = 'small', forcedValue, onMaskSelection, ...popoverTriggerProps })=>{
    const { selectedItems, open } = useDropdownContext();
    const selectedValues = selectedItems.map((item)=>item.label).join(', ');
    const translatedSelectedValues = onMaskSelection?.(selectedValues) || selectedValues;
    return /*#__PURE__*/ jsx(PrimitiveDropdownTrigger, {
        asChild: true,
        ...popoverTriggerProps,
        children: /*#__PURE__*/ jsx(PrimitiveDropdownValueButton, {
            className: className,
            size: size,
            open: open,
            placeholder: placeholder,
            value: forcedValue ?? translatedSelectedValues
        })
    });
};
const DropdownContent = PrimitiveDropdownContent;
const DropdownSearchInput = PrimitiveDropdownClientSearch;
const DropdownClearButton = ({ label, className, unstyled = false })=>{
    const { setValues } = useDropdownContext();
    const handleClearAll = ()=>setValues([]);
    return /*#__PURE__*/ jsx("button", {
        type: "button",
        onClick: handleClearAll,
        className: cn(!unstyled && 'tw-w-full tw-text-left tw-py-1.2 tw-px-2.4 tw-font-caption tw-text-primary-light-500 dark:tw-text-secondary-light-500 hover:tw-text-primary-light-400 hover:dark:tw-text-secondary-light-400 hover:tw-bg-neutral-light-300 dark:hover:tw-bg-neutral-dark-600', className),
        id: "clear-all",
        children: label
    });
};
const DropdownEmpty = PrimitiveDropdownEmpty;
export { Dropdown, DropdownClearButton, DropdownContent, DropdownEmpty, DropdownSearchInput, DropdownTrigger, DropdownValue };
